module.exports = __webpack_public_path__ + "static/media/magazine.5ff7d109.svg";